import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import ResponsiveDrawer from "views/components/ResponsiveDrawer";
import { MaterialReactTable } from "material-react-table";
import AllKampoData from "data/all-kampo.json";

function AllKampo() {
  const columns = useMemo(
    () => [
      {
        accessorKey: "name",
        header: "名前",
      },
      {
        accessorKey: "set",
        header: "生薬",
      },
    ],
    []
  );

  return (
    <ResponsiveDrawer>
      <div style={{ maxWidth: "calc(100vw - 48px)" }}>
        <MaterialReactTable
          columns={columns}
          data={AllKampoData}
          enableColumnFilterModes
          enableColumnOrdering
          enableGrouping
          enablePinning
          enableRowSelection={false}
          initialState={{ density: "compact" }}
          renderTopToolbarCustomActions={() => (
            <Typography paragraph style={{ margin: 0 }}>漢方方剤</Typography>
          )}
        />
      </div>
    </ResponsiveDrawer>
  );
}

export default AllKampo;
